import * as NavActions from '../../../store/returns/nav/returns.nav.actions';
import * as ReturnsActions from '../../../store/returns/returns.actions';
import * as SellerActions from '../../../store/seller/seller.actions';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';
import { calculatePagingStats, getFilteredPagingStats } from '../../../services/pagination-service';

import * as Actions from './returns.grid.actions';
import { APP_INITIALIZATION } from '../../core/base-actions';

const initialState = {
  isLoading: true,
  returns: [],
  // ...initialPagingStats,

  // fake data that needs to be removed beyond this point.
  // I'm pretty sure this can all be removed
  totalRecords: 50000,
  ...getFilteredPagingStats(1, 250, 50000, 250),
};

const getUserSettingsState = (state, data) => {
  const userSettings = data.userSettings || [];
  const gridConfigUserSettings = userSettings.filter((setting) => setting.settingName.includes('v3.returns.gridConfig'));
  if (!gridConfigUserSettings) {
    return state;
  }
  return {
    ...state,
    columnConfiguration: gridConfigUserSettings.reduce((gridConfigMap, setting) => {
      const splitSettingName = setting.settingName.split('.');
      const statusIdStringIndex = 3;
      const statusViewId = splitSettingName[statusIdStringIndex];
      return {
        ...gridConfigMap,
        [statusViewId]: JSON.parse(setting.settingValue),
      };
    }, {}),
  };
};

const actionHandlerMap = {
  [Actions.RETURNS_GRID_SET_IS_LOADING]: (state, { isLoading }) => {
    return {
      ...state,
      isLoading,
    };
  },
  [Actions.RETURNS_GRID_CHANGE_PAGE]: (state, { newPage, pageSize }) => {
    return {
      ...state,
      // isLoading: true,
      ...getFilteredPagingStats(newPage, pageSize, state.totalRecords, state.pageSize),
    };
  },
  [ReturnsActions.RETURNS_GRID_GET_RETURNS_SUCCESS]: (state, { returns, page, pageSize, totalCount }) => {
    const pagingStats = calculatePagingStats(page, pageSize, totalCount);
    return {
      ...state,
      isLoading: false,
      returns,
      ...pagingStats,
    };
  },
  [ReturnsActions.RETURNS_GRID_GET_RETURNS_FAILURE]: (state) => {
    return {
      ...state,
      isLoading: false,
    };
  },
  [NavActions.RETURNS_CHANGE_VIEW]: (state, { goToPageOne }) => {
    const newPage = goToPageOne ? 1 : state.page;
    const pagingStats = calculatePagingStats(newPage, state.pageSize, state.totalRecords);
    return {
      ...state,
      ...pagingStats,
    };
  },
  [Actions.RETURNS_GRID_CHANGE_COLUMNS]: (state, { statusViewId, columns }) => {
    return {
      ...state,
      columnConfiguration: {
        ...state.columnConfiguration,
        [statusViewId]: columns,
      },
    };
  },
  [Actions.RETURNS_GRID_CHANGE_ORDERBY]: (state, { statusViewId, columns }) => {
    return {
      ...state,
      columnConfiguration: {
        ...state.columnConfiguration,
        [statusViewId]: columns,
      },
    };
  },
  [APP_INITIALIZATION]: (state, { initialData }) => {
    return getUserSettingsState(state, initialData);
  },
  [SellerActions.GET_SELLER_DATA_SUCCESS]: (state, { data }) => {
    return getUserSettingsState(state, data);
  },
  [NavActions.RETURNS_SEARCH_SUCCESS]: (state, { results }) => {
    const { pageData, page, pageSize, totalCount } = results;
    const pagingStats = calculatePagingStats(page, pageSize, totalCount);
    return {
      ...state,
      isLoading: false,
      returns: pageData,
      ...pagingStats,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './returns.grid.reducer.metadata';
